<template>
    <div
        class="form-hall-list"
        :class="{active: active }"
    >
        <header class="form-hall-list-header">
            <div class="form-hall-list-title">
                Wybierz halę
            </div>
            <span class="close" @click="close" >
                &#x2715;
            </span>
        </header>
        <div class="form-hall-list-items">

            <div v-if="!items.length"  class="text-center">
                <Loader is-active />
            </div>

            <template v-for="item in sortedItems">
                <div
                    class="form-hall-list-item"
                    :key="item.makroId"
                    :class="{selected: selected === item.makroId}"
                    @click="selectItem(item)"
                >
                    <div>
                        <div class="form-hall-list-item-title">
                            {{ item.name }}
                        </div>
                        <div class="form-hall-list-item-address">
                            {{ item.address }};
                            {{ item.postCode }}
                            {{ item.city }}
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <div class="form-hall-list-overlay" @click="close" />

    </div>
</template>

<script>
    import Loader from '@/components/loader/Loader'
    export default {
        name: "FormHallList",
        components: {Loader},
        props: {
            items: {
                type: Array,
                required: true
            },
            selected: {
                type: String,
                default: ''
            }
        },
        data () {
            return {
                active: false
            }
        },
        computed: {
            sortedItems () {
                if (!this.items.length) {
                    return []
                }
                const itemsToSort = this.items
                return itemsToSort.sort((a, b) => {
                    if (a.city.localeCompare(b.city) !== 0) {
                        return a.city.localeCompare(b.city)
                    }
                    return a.name.localeCompare(b.name)
                })
            }
        },
        methods: {
            close () {
                this.active = false
                console.log('try to closs')
            },
            open () {
                this.active = true
            },
            selectItem (item) {
                console.log('select hall', item)
                this.$emit('select', item)
                this.close()
            }
        }
    }
</script>

<style lang="scss">
    @import "src/assets/scss/_variables/color";
    @import "src/assets/scss/_variables/fonts";

    .form-hall-list {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        max-width: 650px;
        width: 100%;
        box-shadow: #5555 0 0 6px;
        background-color: #fff;
        z-index: 10;
        transition: .3s;
        transform: translateX(101%);
        color: $color-default;

        &.active {
            transform: translateX(0);

            .form-hall-list-overlay {
                visibility: visible;
            }
        }

        .close {
            cursor: pointer;
            position: absolute;
            top: 9px;
            right: 25px;
            font-size: 2.7rem;
            font-weight: 600;
            color: $color-lime;
        }

        &-header {
            padding: .8em;
            position: relative;
            height: 55px;
        }

        &-title {
            font-size: 2.4rem;
            font-weight: $font-weight-bold;
            color: $color-primary;
            text-align: center;


        }

        &-items {
            position: absolute;
            top: 55px;
            left: 0;
            right: 0;
            bottom: 0;
            overflow: auto;
        }

        &-overlay {
            // background-color: red;
            position: absolute;
            right: 0;
            top: 0;
            bottom: 0;
            width: 300%;
            z-index: -1;
            visibility: hidden;

        }

        &-item {
            cursor: pointer;
            padding: 10px 15px 20px 65px;
            position: relative;

            &-title {
                font-size: 1.8rem;
                font-weight: $font-weight-bold;
            }
            &-address {
                font-size: 1.6rem;
            }

            &:before {
                width: 25px;
                height: 25px;
                border: 2px solid $color-border;
                border-radius: 50%;
                content: '';
                display: block;
                position: absolute;
                left: 15px;
                top: 13px;
            }

            &:after {
                position: absolute;
                width: 15px;
                height: 15px;
                border-radius: 50%;
                content: '';
                background-color: $color-positive;
                left: 15px + (29 - 15) / 2;
                top: 13px + (29 - 15) / 2;
                opacity: 0;
                transition: .3s opacity linear;
            }

            &:hover:not(.selected) {
                color: $color-primary;
            }

            &.selected {
                cursor: default;

                &:after {
                    opacity: 1;
                }
            }
        }
    }
</style>
